import { noChange } from 'lit';
import { directive, Directive } from 'lit/directive.js';
import { extractElement } from './directive-util';
export function listen(eventType, listener) {
    return listenDirective(eventType, listener);
}
/**
 * The directive generics here are not strong enough to maintain their values. Thus, the directive
 * call is wrapped in the function above.
 */
const listenDirective = directive(class extends Directive {
    constructor(partInfo) {
        super(partInfo);
        this.element = extractElement(partInfo, 'listen', HTMLElement);
    }
    resetListener(listenerMetaData) {
        if (this.lastListenerMetaData) {
            this.element.removeEventListener(this.lastListenerMetaData.eventType, this.lastListenerMetaData.listener);
        }
        this.element.addEventListener(listenerMetaData.eventType, listenerMetaData.listener);
        this.lastListenerMetaData = listenerMetaData;
    }
    createListenerMetaData(eventType, callback) {
        return {
            eventType,
            callback,
            listener: (event) => { var _a; return (_a = this.lastListenerMetaData) === null || _a === void 0 ? void 0 : _a.callback(event); },
        };
    }
    render(eventTypeInput, callback) {
        const eventType = typeof eventTypeInput === 'string' ? eventTypeInput : eventTypeInput.type;
        if (typeof eventType !== 'string') {
            throw new Error(`Cannot listen to an event with a name that is not a string. Given event name: "${eventType}"`);
        }
        if (this.lastListenerMetaData && this.lastListenerMetaData.eventType === eventType) {
            /**
             * Store the callback here so we don't have to update the attached listener every
             * time the callback is updated.
             */
            this.lastListenerMetaData.callback = callback;
        }
        else {
            this.resetListener(this.createListenerMetaData(eventType, callback));
        }
        return noChange;
    }
});
